import React from 'react';

const TabsContext = React.createContext();

export { TabsContext as default };
